"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "LocalePicker", {
    enumerable: true,
    get: function() {
        return LocalePicker;
    }
});
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _localisationeq1 = require("@equiem/localisation-eq1");
const _ri = require("react-icons/ri");
const _DropdownNestedMenu = require("../Dropdown/DropdownNestedMenu/DropdownNestedMenu");
const _LocalePickerOptions = require("./LocalePickerOptions");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const LocalePicker = (param)=>{
    let { languages, debugLanguages, showSelected, showDebugLanguages = false } = param;
    const { t, i18n, ready } = (0, _localisationeq1.useTranslation)();
    var _getDisplayName;
    return /*#__PURE__*/ _react.default.createElement(_DropdownNestedMenu.DropdownNestedMenu, {
        className: "locale-picker",
        icon: _ri.RiGlobalLine,
        title: (_getDisplayName = (0, _LocalePickerOptions.getDisplayName)(i18n.language, showDebugLanguages)) !== null && _getDisplayName !== void 0 ? _getDisplayName : t("common.language"),
        disabled: !ready,
        maxHeight: 300
    }, /*#__PURE__*/ _react.default.createElement(_LocalePickerOptions.LocalePickerOptions, {
        languages: languages,
        debugLanguages: debugLanguages,
        showSelected: showSelected,
        showDebugLanguages: showDebugLanguages
    }));
};

//# sourceMappingURL=LocalePicker.js.map